import styled from 'styled-components';

import { Button } from '..';

export const ActionButton = styled(Button)`
  padding: 5px;
  width: 35px;
  border-width: 0;
  background-color: white;
`;
